import React, { useEffect } from "react";
import Fade from "react-reveal/Fade";
import { useContent } from "../../hooks/useContent";
import { useTranslation } from "react-i18next";

const WhoAreWe = () => {
  const { who, fetchWho } = useContent();
  const { i18n } = useTranslation()

  useEffect(() => {
    fetchWho();
  }, [i18n.language]);

  return (
    <div className="py-20 md:px-60 text-lg font-medium bg-bgGray">
      <div className="relative mb-14">
        <Fade bottom>
          <img
            className="w-2/3 rounded-2xl hidden md:block"
            src={who.who_image}
            alt="صورة من نحن"
          />
        </Fade>
        <Fade top>
          <div className="max-h-[608px] overflow-auto p-10 rounded-2xl bg-white m-2 md:w-96 md:absolute relative md:top-20 md:left-0">
            <h1 className="font-semibold text-4xl text-purple pb-3 break-words line-clamp-3 ">
              {/* من نحن */}
              {who.who_title}
            </h1>
            <p className="text-lightGray font-medium break-words  ">
              {/* شركة رائدة في تطوير الأعمال بالمملكة العربية السعودية وذاخرة
              بأعمالها المتنوعة متعددة المجالات */}
              {who.who_content}
            </p>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default WhoAreWe;
